import React from "react";
var __jsx = React.createElement;
import FlowStepTitle from "@/pages/sell-my-car/components/FlowStepTitle";
import FlowOption from "@/pages/sell-my-car/components/FlowOption";
import FlowOptionBody from "@/pages/sell-my-car/components/FlowOptionBody";
import { useTranslation } from "@i18n";
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { CDN_LINK } from "@globalConfig";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo, toSnakeCase } from "@/utils/GlobalJavascriptFunction";
import { SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import useBoolean from "@hooks/useBoolean";
import { useEffect } from "react";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import FlowOptionLoading from "@/pages/sell-my-car/components/FlowOptionLoading";
var CarOwnerShipScreen = function CarOwnerShipScreen() {
  var _useScreenNavigation = useScreenNavigation(),
    navActions = _useScreenNavigation.actions;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var loading = useBoolean(true);
  useEffect(function () {
    setTimeout(function () {
      loading.setFalse();
    }, 300);
  }, []);
  var handleOwnerShipSelect = function handleOwnerShipSelect(ownership) {
    var _state$selection, _state$selection$make, _state$selection2, _state$selection2$mod, _state$selection3, _state$selection3$ext, _state$selection4, _state$selection5, _state$selection5$odo;
    navActions.navigateToScreen(SELL_CAR_SCREENS.CONTACT_INFO);
    trackEvents("sell_car_details_submit", {
      car_make: state === null || state === void 0 ? void 0 : (_state$selection = state.selection) === null || _state$selection === void 0 ? void 0 : (_state$selection$make = _state$selection.make) === null || _state$selection$make === void 0 ? void 0 : _state$selection$make.name,
      car_model: state === null || state === void 0 ? void 0 : (_state$selection2 = state.selection) === null || _state$selection2 === void 0 ? void 0 : (_state$selection2$mod = _state$selection2.model) === null || _state$selection2$mod === void 0 ? void 0 : _state$selection2$mod.name,
      car_trim: state === null || state === void 0 ? void 0 : (_state$selection3 = state.selection) === null || _state$selection3 === void 0 ? void 0 : (_state$selection3$ext = _state$selection3.extension) === null || _state$selection3$ext === void 0 ? void 0 : _state$selection3$ext.name,
      car_year: state === null || state === void 0 ? void 0 : (_state$selection4 = state.selection) === null || _state$selection4 === void 0 ? void 0 : _state$selection4.year,
      car_odometer_range: state === null || state === void 0 ? void 0 : (_state$selection5 = state.selection) === null || _state$selection5 === void 0 ? void 0 : (_state$selection5$odo = _state$selection5.odometerRange) === null || _state$selection5$odo === void 0 ? void 0 : _state$selection5$odo.range_ar,
      ownership_type: toSnakeCase(ownership),
      platform: getPlatformInfo(),
      version: "3"
    });
    actions.selectOwnership(ownership);
  };
  return /*#__PURE__*/React.createElement("div", {
    id: "sell-car-ownership-screen",
    className: "p-4 flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement(FlowStepTitle, null, tShort("sell_trade_v2/choose_ownership", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement(Conditional, {
    condition: (state === null || state === void 0 ? void 0 : state.isLoading) || loading.value
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FlowOptionLoading, {
    className: "md:h-[106px]",
    length: 2,
    gridClassName: "md:grid-cols-3"
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-ownership-list",
    className: "flex flex-col gap-3 md:grid md:grid-cols-3 md:gap-8"
  }, /*#__PURE__*/React.createElement(FlowOption, {
    key: "owned",
    id: "sell-car-ownership-option-owned",
    onClick: function onClick() {
      return handleOwnerShipSelect("Owned");
    }
  }, /*#__PURE__*/React.createElement(FlowOptionBody, {
    name: tShort("sell_trade_v2/owned", {
      ns: "web_sell_trade"
    }),
    imgUrl: CDN_LINK + "/assets/images/car-owned.svg"
  })), /*#__PURE__*/React.createElement(FlowOption, {
    key: "Not Owned",
    id: "sell-car-ownership-option-not-owned",
    onClick: function onClick() {
      return handleOwnerShipSelect("Not Owned");
    }
  }, /*#__PURE__*/React.createElement(FlowOptionBody, {
    name: tShort("sell_trade_v2/not_owned", {
      ns: "web_sell_trade"
    }),
    imgUrl: CDN_LINK + "/assets/images/car-not-owned.svg"
  }))))));
};
export default CarOwnerShipScreen;